<template>
  <label class="custom-toggle" :class="switchClass">
    <input v-model="model" type="checkbox" />
    <span
      class="custom-toggle-slider rounded-circle"
      :data-label-off="offText"
      :data-label-on="onText"
    >
    </span>
  </label>
</template>
<script>
export default {
  name: 'BaseSwitch',
  props: {
    value: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    type: String,
    onText: {
      type: String,
      default: 'Si',
    },
    offText: {
      type: String,
      default: 'No',
    },
  },
  emits: ['input'],
  computed: {
    switchClass () {
      let baseClass = 'custom-toggle-';
      if (this.type) {
        return baseClass + this.type;
      }
      return '';
    },
    model: {
      get () {
        console.log(this.value);
        return this.value;
      },
      set (value) {
        console.log({ value });
        this.$emit('input', value);
      },
    },
  },
  methods: {
    triggerToggle () {
      this.model = !this.model;
    },
  },
};
</script>
<style></style>
